export default "34a62ecb2f45490ad2feaf6c8999f70a.svg";